import { useCallback, useMemo, useState } from 'react';
import { createUserPreferenceStore } from '../../../../lib/preferences';
import { useCurrentSession } from '../../../../stores/session';

// ADR 0062 §6.1: the notes from moving a job off its screening criteria ("2 left out — …") are shown once on the card. Seeing them is
// remembered per person and per job, as the card's fold is.

const SEEN_KEY_PREFIX = 'ranking.icp-notes-seen.';

interface IcpNotesSeen {
  readonly isSeen: boolean;
  readonly markSeen: () => void;
}

export function useIcpNotesSeen(jobId: string): IcpNotesSeen {
  const userId = useCurrentSession()?.id ?? 'anonymous';
  const store = useMemo(() => createUserPreferenceStore(userId), [userId]);
  const key = `${SEEN_KEY_PREFIX}${jobId}`;
  const [state, setState] = useState(() => ({ key, isSeen: store.get<unknown>(key, false) === true }));
  // Another job's page reuses this component: read its own choice rather than carry this one over.
  const isSeen = state.key === key ? state.isSeen : store.get<unknown>(key, false) === true;
  const markSeen = useCallback((): void => {
    setState({ key, isSeen: true });
    store.set(key, true);
  }, [store, key]);
  return { isSeen, markSeen };
}
